import { useEffect } from "react";
import { useLanguage } from "../i18n/LanguageContext";

const SITE = "https://horizonadvisorscy.com";

export const Seo = ({ page, path }) => {
  const { t, lang } = useLanguage();
  const { title, desc } = t.seo[page];

  useEffect(() => {
    document.title = title;
    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    setMeta('meta[name="description"]', "content", desc);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", desc);
    setMeta('meta[property="og:url"]', "content", `${SITE}${path}`);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", desc);
    setMeta('link[rel="canonical"]', "href", `${SITE}${path}`);
    setMeta('meta[property="og:locale"]', "content", lang === "el" ? "el_CY" : lang === "ru" ? "ru_RU" : "en_US");
    window.scrollTo(0, 0);
  }, [title, desc, path, lang]);

  return null;
};
